export function addCurrent(customer) {
  return {
    type: 'ADD_CURRENT',
    customer,
  }
}
